import { render, staticRenderFns } from "./dataRecord.vue?vue&type=template&id=1a5f3912&scoped=true"
import script from "./dataRecord.vue?vue&type=script&lang=js"
export * from "./dataRecord.vue?vue&type=script&lang=js"
import style0 from "./dataRecord.vue?vue&type=style&index=0&id=1a5f3912&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5f3912",
  null
  
)

export default component.exports